<template>
    <div class="map-holder" v-clickoutside="hideModal">
        <div class="modal-card">
            <span class="store-name">{{ store.name }}</span>
            <i class="icon ico-close store-close" alt="Close icon" @click="hideModal()"> </i>
            <span class="store-id">ID {{ store.identifier }}</span>
            <span class="store-description">Sucursal</span>
            <div class="ap-box">
                <img src="@/assets/icons/router-store-card.svg" alt="Router icon">
                <span class="ap-count">9</span>
                <span class="ap-title">AP Sincronizados</span>
            </div>
            <div class="store-separator"></div>
            <div class="store-section">
                <span class="store-section-title">Ubicación:</span>
                <span class="store-section-description" v-if="store.address">{{ store.address }}</span>
                <span class="store-section-description" v-else>Sin información</span>
            </div>
            <div class="store-section">
                <span class="store-section-title">Teléfono:</span>
                <span class="store-section-description" v-if="store.phone">{{ store.phone }}</span>
                <span class="store-section-description" v-else>Sin información</span>
            </div>
            <div class="store-section">
                <span class="store-section-title">Horarios:</span>
                <span class="store-section-description" v-if="store.week_schedule">Lunes a Viernes - {{ store.week_schedule }} hrs</span>
                <span class="store-section-description" v-if="store.weekend_schedule">Lunes a Viernes - {{ store.weekend_schedule }} hrs</span>
            </div>
            <div class="store-section">
                <span class="store-section-title">Servicios:</span>
                <ul class="store-section-list" v-if="store.services.length > 0">
                    <li v-for="(service, key) in store.services" :key="key">- {{ service.name }}</li>
                </ul>
                <ul class="store-section-list" v-else>
                    <li>- Sin información de los servicios disponibles</li>
                </ul>
            </div>
        </div>
        <div class="close-modal" @click="hideModal"></div>
    </div>
</template>

<script>
export default {
    name: 'StoreModal',
    props: ['store','show'],
    data: function(){
        return {
            hide: false
        }
    },
    methods: {
        hideModal: function() {
            if (this.show){
                if (this.hide) {
                    this.$emit("closeModal");
                }
                this.hide = true
            }
        }
    },
    directives: {
        clickoutside: {
            bind: function (el, binding, vnode) {
                el.clickOutsideEvent = function (event) {
                // here I check that click was outside the el and his childrens
                if (!(el == event.target || el.contains(event.target))) {
                    // and if it did, call method provided in attribute value
                    vnode.context[binding.expression](event);
                }
                };
                document.body.addEventListener('click', el.clickOutsideEvent)
            },
            unbind: function (el) {
                document.body.removeEventListener('click', el.clickOutsideEvent)
            },
            stopProp(event) { event.stopPropagation() }
        }
    }
}
</script>

<style lang="sass">
.map-holder
    grid-column-start: 2
    grid-column-end: 6
    grid-row-start: 2
    grid-row-end: 2
    z-index: 8
    display: flex
.close-modal
    grid-column-start: 2
    grid-column-end: 6
    grid-row-start: 2
    grid-row-end: 3
    width: 100%
    height: 452px
    // background: red
    z-index: 7
.modal-card
    display: block
    width: 377px
    border-radius: 4px
    box-shadow: 0 2px 10px 0 rgba(173, 182, 212, 0.45)
    background-color: #ffffff
    z-index: 9
    padding: 16px
    grid-column-start: 2
    grid-row-start: 2
    grid-row-end: 2
    i
        color: $light-grey
    i:hover
        color: $secondary-hover
    span
        margin: 2px 0

    .store-name
        display: inline-block
        font-family: Montserrat
        font-size: 20px
        font-weight: 600
        color: #302f2f

    .store-close
        float: right
        width: 16px
        height: 16px
        cursor: pointer

    .store-id
        display: block
        font-family: Montserrat
        font-size: 14px
        font-weight: 600
        color: #302f2f

    .store-description
        font-family: Muli
        font-size: 12px
        font-weight: 300
        color: #302f2f

    .ap-box
        display: block
        width: 83px
        margin: 22px auto 0

        img
            width: 24px
            height: 24px
            display: inline-block
            margin-left: 1px

        .ap-count
            display: inline-block
            margin-left: 8px
            font-family: Montserrat
            font-size: 14px
            font-weight: 600
            text-align: center
            color: #302f2f
            min-width: 50px
        
        .ap-title
            display: block
            font-family: Muli
            font-size: 10px
            text-align: center
            color: #302f2f

    .store-separator
        display: block
        width: 100%
        height: 1px
        background-color: #d3dce1
        margin: 16px 0

    .store-section
        display: block
        margin-bottom: 16px

        .store-section-title
            display: block
            font-family: Montserrat
            font-size: 14px
            font-weight: 600
            color: #302f2f

        .store-section-description
            display: block
            font-family: Muli
            font-size: 12px
            font-weight: 300
            color: #302f2f
            margin-top: 4px

        .store-section-list
            display: block
            list-style: none

            li
                display: inline-block
                width: 50%
                font-family: Muli
                font-size: 12px
                font-weight: 300
                color: #302f2f
                margin-top: 4px
</style>